import React, { FunctionComponent } from 'react';
import type { RecruitmentShowContentDetailsProps } from './types';
import { ContentConditions } from '../../atoms/contentConditions';

type Props = & RecruitmentShowContentDetailsProps & {
  addressConditions: string[];
  workingTimeConditions: string[];
  fetchIndex: (array: string[], target: string) => boolean;
  fetchSalarySection: () => boolean ;
  fetchWelfares: () => boolean;
  fetchAddressSection: () => boolean;
  fetchWorkingTimeSection: () => boolean;
};

export const Presentation: FunctionComponent<Props> = ({
  recruitmentId,
  companyId,
  employmentTypes,
  regularEmployee,
  workingPeriod,
  trialPeriod,
  brands,
  occupationNames,
  address,
  workingTime,
  salary,
  salaryDetail,
  salaryDetailPresent,
  socialInsurances,
  welfares,
  welfareOther,
  welfareOtherPresent,
  plannedHires,
  preferenceConditions,
  updatedAt,
  isStopped,
  isPreview,
  addressConditions,
  workingTimeConditions,
  fetchIndex,
  fetchSalarySection,
  fetchWelfares,
  fetchAddressSection,
  fetchWorkingTimeSection
}) => {
  return (
    <>
      {employmentTypes && employmentTypes.length > 0 &&
        <div className="recruitment__show__content__item">
          <h3 className="subTitle">雇用形態</h3>
          <span>{employmentTypes?.[0]?.name}{regularEmployee ? '(正社員)' : ''}</span>
        </div>
      }
      {workingPeriod !== '' &&
        <div className="recruitment__show__content__item">
          <h3 className="subTitle">契約期間</h3>
          <span>{workingPeriod}</span>
        </div>
      }
      {trialPeriod !== '' &&
        <div className="recruitment__show__content__item">
          <h3 className="subTitle">試用期間</h3>
          <span>{trialPeriod}</span>
        </div>
      }
      {brands !== '' &&
        <div className="recruitment__show__content__item">
          <h3 className="subTitle">ブランド名</h3>
          <span>{brands && brands.officialName}</span>
          <a className="link gtm-recruitment-view-count" href={`/brands/${brands && brands.brandId}`} {...(!isPreview && {'data-event-name': 'recruitments on screen', 'data-event': 'click', 'data-category': isStopped ? 'stoprecruitmentcontent' : 'recruitmentcontent', 'data-value': 'brand_recruitments'})}>{brands && brands.officialName}の求人一覧</a>
        </div>
      }
      {occupationNames && occupationNames.length !== 0 &&
        <div className="recruitment__show__content__item">
          <h3 className="subTitle">職種</h3>
          {occupationNames &&
            occupationNames.map((occupation) => (
              <span key={occupation}>{occupation}</span>
            ))
          }
        </div>
      }
      {plannedHires !== '' &&
        <div className="recruitment__show__content__item">
          <h3 className="subTitle">採用予定人数</h3>
          <span>{plannedHires}</span>
        </div>
      }
      {fetchAddressSection() &&
        <>
          <div className="recruitment__show__content__item">
            <h3 className="subTitle">勤務地</h3>
            {address && address.trim() !== '' && <span>{address}</span>}
            {addressConditions.length > 0 && <ContentConditions items={addressConditions} />}
          </div>
        </>
      }
      {fetchWorkingTimeSection() &&
        <>
          <div className="recruitment__show__content__item">
            <h3 className="subTitle">勤務時間</h3>
            {workingTime && workingTime.trim() !== '' && <span dangerouslySetInnerHTML={{ __html: workingTime }} />}
            {workingTimeConditions.length > 0 && <ContentConditions items={workingTimeConditions} />}
          </div>
        </>
      }
      {preferenceConditions.dressCodeBenefits && preferenceConditions.dressCodeBenefits.length !== 0 &&
        <div className="recruitment__show__content__item">
          <h3 className="subTitle">制服・社割</h3>
          {preferenceConditions.dressCodeBenefits.map((dressCodeBenefit) => (
              <span key={dressCodeBenefit} className="welfare">{dressCodeBenefit}<strong className={`${dressCodeBenefit && fetchIndex(preferenceConditions.dressCodeBenefits, dressCodeBenefit) ? 'devide' : ''}`}>&nbsp;/</strong></span>
            ))
          }
        </div>
      }
      {fetchSalarySection() &&
        <div className="recruitment__show__content__item gtm-recruitment-view-count" data-event-name="recruitments on screen" data-category="recruitmentcontent" data-value="salary" data-recruitmentId={recruitmentId} data-companyId={companyId}>
          <h3 className="subTitle">給与</h3>
          <span>{salary}</span>
          <span dangerouslySetInnerHTML={{ __html: salaryDetail }} className='salary-detail' />
          {preferenceConditions.compensationEvaluations.length > 0 && <ContentConditions items={preferenceConditions.compensationEvaluations} />}
        </div>
      }
      {socialInsurances && socialInsurances.length !== 0 &&
        <div className="recruitment__show__content__item">
          <h3 className="subTitle">社会保険</h3>
          {socialInsurances &&
            socialInsurances.map((socialInsurance) => (
              <span key={socialInsurance} className="welfare">{socialInsurance}
                <strong className={`${socialInsurances && fetchIndex(socialInsurances, socialInsurance) ? 'devide' : ''}`}>
                  &nbsp;/
                </strong>
              </span>
            ))
          }
        </div>
      }
      {fetchWelfares() &&
        <div className="recruitment__show__content__item">
          <h3 className="subTitle">待遇・福利厚生</h3>
          {welfares &&
            welfares.map((welfare) => (
              <span key={welfare} className="welfare">{welfare}<strong className={`${welfares && fetchIndex(welfares, welfare) ? 'devide' : ''}`}>&nbsp;/</strong></span>
            ))
          }
          <span dangerouslySetInnerHTML={{ __html: welfareOther }} className='welfare-detail' />
        </div>
      }
      {preferenceConditions.selectionConfigurations && preferenceConditions.selectionConfigurations.length !== 0 &&
        <div className="recruitment__show__content__item">
          <h3 className="subTitle">選考方法</h3>
          {preferenceConditions.selectionConfigurations.map((selectionConfiguration) => (
              <span key={selectionConfiguration} className="welfare">{selectionConfiguration}
                <strong className={`${preferenceConditions.selectionConfigurations && fetchIndex(preferenceConditions.selectionConfigurations, selectionConfiguration) ? 'devide' : ''}`}>
                  &nbsp;/
                </strong>
              </span>
            ))
          }
        </div>
      }
      <div className="recruitment__show__content__item">
        <h3 className="subTitle">更新日</h3>
        <span>{updatedAt}</span>
      </div>
    </>
  );
};
